import * as React from 'react';
import { TopModel } from '@goldwasserexchange/react-topmodel';
import { DomRippleEffectBase, DomRippleEffectContainer, DomRippleEffectContent, } from './components';
export var rippleEffectDefaultDomTopModelsObject = {
    RippleEffectBase: (React.createElement(TopModel, { name: "RippleEffectBase" }, DomRippleEffectBase)),
    RippleEffectContainer: (React.createElement(TopModel, { name: "RippleEffectContainer" }, DomRippleEffectContainer)),
    RippleEffectContent: (React.createElement(TopModel, { name: "RippleEffectContent" }, DomRippleEffectContent)),
};
